import { styled } from '~/styled'

export const Box = styled('div', {
  base: []
})

Box.displayName = 'Box'
